import { OpenApiParser } from './openapi.parser.js';
import { Logger } from '@flexbase/logger';

export class OpenApiParser3 extends OpenApiParser {
  constructor(logger: Logger) {
    super(logger);
  }
}
